import "./feedback.css";
import StudentFeedback from "./StudentFeedback";
import SCheckBox from "../../components/SCheckBox";
import mut from "../../hooks/mut";
import { ClipboardCheck } from "lucide-react";
import { usePrimaryColor } from "../../components/PrimaryColorContext";


/**
 * Feedback2 - Feedback tab showing homework status and per-student feedback entries
 * @param {object} props
 * @param {object} props.lesson - Lesson record from DB
 * @param {function} props.setLesson - State setter for lesson
 * @returns {JSX.Element}
 * @author opencode (glm-5.1) + Forge
 * @version 2.0.0
 * @since 2026-04-13
 */
export default function Feedback2({ lesson, setLesson }) {
  const { primaryColor } = usePrimaryColor();
  const { attendance } = lesson;

  return (
    <div className="space-y-4">
      <div className="flex w-full">
        <div className="flex-grow">
          <div className="flex items-center">
            <SCheckBox
              label="Homework sent"
              value={lesson.homeworkSent ? true : false}
              setValue={(e) => {
                let update = e
                  ? { homeworkSent: new Date() }
                  : { $unset: { homeworkSent: "" } };
                mut("post", `/lesson/${lesson._id}`, update);
                setLesson((prev) => ({
                  ...prev,
                  homeworkSent: e ? new Date() : false,
                }));
              }}
            />
          </div>
        </div>
      </div>

      <div className="py-1 font-light text-sm text-slate-600 flex items-center gap-2">
        <ClipboardCheck size={14} className={`text-${primaryColor}-800`} />
        Feedback for students
      </div>

      <div className="space-y-2">
        {attendance.map((at) => (
          <StudentFeedback
            attendance={at}
            key={attendance._id}
            setLesson={setLesson}
          />
        ))}
      </div>
    </div>
  );
}
